<template>
  <div class="panel-header panel-header-lg">
    <canvas :id="headerChartID"></canvas>
  </div>
</template>

<script>
  // Chart tem de ser importado aqui.
  // Antes era usado como global (window.Chart), que so existe depois de a
  // chunk dos graficos ser carregada — e essa chunk vinha por prefetch, logo
  // chegava as vezes antes e as vezes depois deste componente montar.
  // Era essa a razao de o grafico so aparecer "as vezes".
  import Chart from "chart.js";
  import api from "@/api/index";
  export default {
    name: "overview-header",
    data() {
      return {
        headerChartID: "headerChart",
        chartInstance: null,
      };
    },
    methods: {
      criarGrafico(chartId, valores) {
        let chartColor = "#FFFFFF";
        // O componente pode ja ter sido desmontado enquanto a API respondia
        // (mudanca de rota rapida) — nesse caso o canvas ja nao existe.
        const canvas = this.$el
          ? this.$el.querySelector("#" + chartId)
          : document.getElementById(chartId);
        if (!canvas) return;
        if (this.chartInstance) this.chartInstance.destroy();
        const ctx = canvas.getContext("2d");
        let gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);

        let gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.24)");
        this.chartInstance = new Chart(ctx, {
          type: "line",
          data: {
            labels: this.labels || [
              "JAN",
              "FEV",
              "MAR",
              "ABR",
              "MAI",
              "JUN",
              "JUL",
              "AGO",
              "SET",
              "OUT",
              "NOV",
              "DEC",
            ],
            datasets: [
              {
                label: "Data",
                borderColor: chartColor,
                backgroundColor: gradientFill,
                pointBorderColor: chartColor,
                pointBackgroundColor: "#1e3d60",
                pointHoverBackgroundColor: "#1e3d60",
                pointHoverBorderColor: chartColor,
                pointBorderWidth: 1,
                pointHoverRadius: 7,
                pointHoverBorderWidth: 2,
                pointRadius: 5,
                fill: true,
                borderWidth: 2,
                data: valores,
              },
            ],
          },
          options: {
            responsive: true,
            layout: {
              padding: {
                left: 20,
                right: 20,
                top: 0,
                bottom: 0,
              },
            },
            maintainAspectRatio: false,
            tooltips: {
              backgroundColor: "#fff",
              titleFontColor: "#333",
              bodyFontColor: "#666",
              bodySpacing: 4,
              xPadding: 12,
            },
            legend: {
              position: "bottom",
              fillStyle: "#FFF",
              display: false,
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    fontColor: "rgba(255,255,255,0.4)",
                    fontStyle: "bold",
                    beginAtZero: true,
                    maxTicksLimit: 5,
                    padding: 10,
                  },
                  gridLines: {
                    drawTicks: true,
                    drawBorder: false,
                    display: true,
                    color: "rgba(255,255,255,0.1)",
                    zeroLineColor: "transparent",
                  },
                },
              ],
              xAxes: [
                {
                  gridLines: {
                    zeroLineColor: "transparent",
                    display: false,
                  },
                  ticks: {
                    padding: 10,
                    fontColor: "rgba(255,255,255,0.4)",
                    fontStyle: "bold",
                  },
                },
              ],
            },
          },
        });
      },
      async inicio() {
        let sessao = null;
        try {
          sessao = JSON.parse(localStorage.getItem("lc_Dashboard_Login"));
        } catch (e) {
          sessao = null;
        }
        if (!sessao || !sessao.cliente) return;

        // Contagem por mês feita no servidor (antes vinham 20 000 leads para contar aqui)
        const r = await api.leadsResumo({ cliente: sessao.cliente });
        if (!r || !Array.isArray(r.por_mes)) return;
        const arrayMeses = r.por_mes;
        this.criarGrafico(this.headerChartID, arrayMeses);
      },
    },
    async mounted() {
      await this.inicio();
    },
    beforeUnmount() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
  };
</script>

<style scoped></style>
